import React, { Component, PropTypes } from 'react';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';
import PersistentAlertBox from './persistent-alert-box'

export class ValidationError extends Component {
  render() {
    const {isValid, errors, css} = this.props;

    var errorList = errors && errors.map( (error, i) => (
      <li role="presentation" key={i} className={css.errorMessage}>
        { error.errorMessage + ": " + error.context}
      </li> ));

    var errorDisplay = null;
    if(!isValid) {
      errorDisplay =
      (
        <div className={css.errorWrapper}>
          <span>The following validation errors occured:</span>
              <div>
                <br />
                <ul>
                  {errorList}
                </ul>
            </div>
        </div>
      )
    }

    return (
      <div className={css.marginWrapper}>
        {errorDisplay}
        <PersistentAlertBox>
          <span>The following validation errors occured:</span>
          {errorList}
        </PersistentAlertBox>
      </div>
    );
  }
}

ValidationError.propTypes = {
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired
};

export default styleable(defaultStyle) (ValidationError);



// WEBPACK FOOTER //
// src/common/validation-error.js